import axios from 'axios';
import AuthService from './auth-header';
// /*dev*/const API_URL = 'https://ats.sattvahuman.in/api/';
// /*prod*/ // const API_URL = 'https://ats.sattvahuman.in/api/';
let API_URL = ''
if (process.env.NODE_ENV === "production") {
  API_URL = 'https://ats.sattvahuman.in/api/';
} else {
  API_URL = 'http://192.168.0.30:5000/api/';
}
class UserService {
  //Not in use
  getPublicContent() {
    return axios.get(API_URL + 'dashboard/all');
  }
  //Not in use
  getUserBoard() {
    return axios.get(API_URL + 'dashboard/user', { headers: AuthService.authHeader() });
  }
  //Not in use
  getModeratorBoard() {
    return axios.get(API_URL + 'dashboard/mod', { headers: AuthService.authHeader() });
  }
  async getAdminBoard(v) {
    try {
      //console.log(id)
      const res = await axios.get(API_URL + 'dashboard/admin/' + v,
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err.response);
      return err.response
    }
  }
  async getUserDetail(id) {
    try {
      console.log(id)
      const res = await axios.get(API_URL + 'user/mgr/' + id,
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err);
      return err
    }
  }
  async getAllUsers() {
    try {
      const res = await axios.get(API_URL + 'user',
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err);
      return err
    }
  }
  async getAllUsersForEvents() {
    try {
      const res = await axios.get(API_URL + 'users/dd',
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err.response);
      return err.response
    }
  }
  async getAllUsersDd() {
    try {
      const res = await axios.get(API_URL + 'users',
        {
          headers: AuthService.authHeader()
        });
      // console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err.response);
      return err.response
    }
  }
  async getAllUsersDdActiveInactive() {
    try {
      const res = await axios.get(API_URL + 'users/all',
        {
          headers: AuthService.authHeader()
        });
      // console.log(res.data)
      return res.data
    }
    catch (err) {
      // console.log(err.response);
      return err.response
    }
  }
  /**
   * NOTE (investigated while chasing a "some direct reports missing"
   * report in the Task/Attendance modules — see `manager-id-matcher.js`):
   * this call sends ONLY `emp_id`, no `page`/`limit`/`cursor` param of any
   * kind, and the frontend does not slice/truncate `res.data` anywhere
   * before it reaches `filterToManagerReports()` / the Attendance mixin's
   * own filter. If a manager with a genuinely large team is ever reported
   * missing MORE reports than client-side filtering could plausibly
   * explain, suspect the backend silently paginating/capping this
   * endpoint's response server-side — that would NOT be fixable from this
   * file without the backend first documenting/adding pagination params
   * for this route.
   */
  async getAllTeamMembersList(emp_id) {
    try {
      const res = await axios.get(API_URL + 'users/team-members?emp_id=' + emp_id,
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err.response);
      return err.response
    }
  }
  async getAllRecruitersList(emp_id) {
    try {
      const res = await axios.get(API_URL + 'users/recruiters',
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err.response);
      return err.response
    }
  }
  async getAllManagersList(emp_id) {
    try {
      const res = await axios.get(API_URL + 'users/managers',
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err.response);
      return err.response
    }
  }
  async deleteUser(id) {
    try {
      const res = await axios.delete(API_URL + 'user/' + id,
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err);
      return err.response || err
    }
  }
  async updateUser(id) {
    try {
      const res = await axios.put(API_URL + 'user' + id,
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err);
      return err
    }
  }
  async resetPassword(data) {
    try {
      console.log('in update password')
      const res = await axios.put(API_URL + 'user/reset-pwd/' + data.email, data,
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err, err.response);
      return err.response
    }
  }
  /**
   * Server-side FCM proxy — browser must NOT call fcm.googleapis.com (CORS +
   * server key exposure). See backend-handoff/TASK_MANAGEMENT_API_DOCUMENTATION.md §5.4.
   *
   * @param {{ userIds?: number[], empIds?: string[], title: string, body?: string, data?: object }} body
   * @returns {{ status: string, sent?: number, failed?: number, message?: string }}
   */
  async sendNotifyPush(body) {
    try {
      const res = await axios.post(`${API_URL}notify/push`, body, {
        headers: AuthService.authHeader(),
      })
      return { ...(res.data || {}), httpStatus: res.status }
    } catch (err) {
      const status = err?.response?.status
      if (status === 404 || status === 501) {
        return {
          status: 'NOT_IMPLEMENTED',
          httpStatus: status,
          sent: 0,
          message: 'Push proxy not available.',
        }
      }
      const data = err?.response?.data
      if (data && typeof data === 'object') {
        return { ...data, httpStatus: status }
      }
      return {
        status: status === 403 ? 403 : 'ERROR',
        httpStatus: status,
        sent: 0,
        message: (data && typeof data === 'string' ? data : null) || err.message || 'Push send failed.',
      }
    }
  }

  /** @deprecated Use sendNotifyPush via fcm-push.js — direct FCM from browser is blocked by CORS. */
  async pushNotification() {
    return { status: 'DEPRECATED', sent: 0, message: 'Direct FCM from browser is disabled.' }
  }
  async setToken(id, token) {
    try {
      const res = await axios.put(API_URL + 'user/token/' + id, token, {
        headers: AuthService.authHeader(),
      })
      return res.data
    } catch (err) {
      const status = err?.response?.status
      const data = err?.response?.data
      if (status === 403) {
        return {
          status: 'FORBIDDEN',
          httpStatus: 403,
          message: (data && data.message) || 'Access denied',
        }
      }
      return data && typeof data === 'object'
        ? { ...data, httpStatus: status }
        : { status: 'ERROR', httpStatus: status, message: err.message || 'Token save failed.' }
    }
  }

  async getToken(body) {
    try {
      const res = await axios.get(API_URL + 'user/token/' + body,
        {
          headers: AuthService.authHeader()
        });
      console.log(res.data)
      return res.data
    }
    catch (err) {
      console.log(err)
      console.log(err.response)
      return err.response
    }
  }
  async getUserList() {
    try {
      const res = await axios.get(API_URL + 'user/list',
        {
          headers: AuthService.authHeader()
        });
      // console.log(res.data)
      return res
    }
    catch (err) {
      // console.log(err)
      console.log(err.response)
      return err.response
    }
  }
}
export default new UserService();